export enum DriverClass {
  CLASS_D = 'Class D - Standard',
  CLASS_CDL_A = 'Class CDL-A - 18 wheelers, tractor trailers, large buses',
  CLASS_CDL_B = 'Class CDL-B - School buses, city buses',
  CLASS_C = 'Class C - hazmat vans, 16 or more passenger vans',
  CLASS_M = 'Class M - Motorcycle',
}
